import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { OpDescr } from './op-descr'

export class OpCommandCodeType implements IReferenceType, IOpChangeState, IJsonSerializable {
    //Properties
    public idCommandCode: number
    public name: string
    public idServer: number
    public idDescr: number
    //Properties end
    //NavigationProperties
    public descr: OpDescr
    //NavigationProperties end

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdCommandCodeType
    }
    public getReferenceKey(): number {
        return this.idCommandCode
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idCommandCode = opObj.ID_COMMAND_CODE
            this.idDescr = opObj.ID_DESCR
            this.name = opObj.NAME
            this.idServer = opObj.ID_SERVER
            this.opState = opObj.OpState

            this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
        }

    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_COMMAND_CODE: this.idCommandCode,
            NAME: this.name,
            ID_DESCR: this.idDescr,
            _Descr: this.descr != null ? this.descr.toJSON() : null,
            OpState: this.opState
        }
    }

    public toString() {
        return this.name
    }
}